/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {privacyVaultGetShard} from '../api'

export const useMutationPrivacyVaultGetShard = createReactQueryMutationHook('privacyVaultGetShard', privacyVaultGetShard)
